export const whiteSpace = {
  NORMAL: 'normal',
  PRE_LINE: 'pre-line',
  BREAK_SPACES: 'break-spaces'
} as const

export type WhiteSpaceKeyType = (typeof whiteSpace)[keyof typeof whiteSpace]
